<template>
  <VView class="contest-instructions-2" back-button-to="/menu" :header="$t('contestInstructions.header')">
    <VText>Pufek czerpie moc z magicznych kryształów więc musisz pilnować , aby poziom jego energii nie spadł do zera. Gra wtedy się zakończy!</VText>

    <VBlock max-width="764px">
      <img src="@/assets/instructions-2.png" />
    </VBlock>

    <VBlock max-width="500px">
      <transition name="bounceUp" appear>
        <VButton to="/contest/instructions-3">Dalej</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
export default {
  name: 'ContestInstructions2',
};
</script>

<style lang="scss" scoped>
.contest-instructions-2 {}
</style>
